import { Box, Drawer, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import { PlaceForm } from '../PlaceForm/PlaceForm';
import { useCreatePlaceDrawer } from './useCreatePlaceDrawer';

interface CreatePlaceDrawerProps {
  isOpen: boolean;
  onClose: (createdPlaceId?: string) => void;
}

export const CreatePlaceDrawer: FunctionComponent<CreatePlaceDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const { errors, onSubmit, register } = useCreatePlaceDrawer(onClose);

  return (
    <Drawer anchor="right" open={isOpen} onClose={() => onClose()}>
      <Box sx={{ mt: 10, mx: 2 }}>
        <Typography variant="h4">Créer un lieu</Typography>
        <PlaceForm
          register={register}
          onSubmit={onSubmit}
          errors={errors}
          submitButtonLabel="Créer"
        />
      </Box>
    </Drawer>
  );
};
